import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ym from "react-yandex-metrika";
import HeadTags from "shared/HeadTags";

const PolititcPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    ym("hit", "/informaciya");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [navigate]);

  return (
        <div className="politic-page">
            <HeadTags
                title='Политика конфиденциальности'
                metaDescription='Политика конфиденциальности'
            />
            <div className="container">
                <p className="text-right"><b>01  декабря 2024 г.</b></p>
                <h1>Политика конфиденциальности</h1>

                <p>Политика в отношении обработки персональных данных</p>

                <h2>1. Общие положения</h2>

                <p>Настоящая политика обработки персональных данных составлена</p>

                <p>в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ Российской Федерации</p>

                <p>«О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению безопасности
                    персональных данных, предпринимаемые ООО «Граф Ягода».</p>

                <p>1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод
                    человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной
                    жизни, личную и семейную тайну.</p>

                <p>1.2. Настоящая политика Оператора в отношении обработки персональных данных применяется ко всей информации, которую
                    Оператор может получить о посетителях веб-сайта <a href="https://graf-yagoda.ru/">https://graf-yagoda.ru/</a></p>

                <h2>2. Основные понятия, используемые в Политике</h2>

                <p>2.1. Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств
                    вычислительной техники;</p>

                <p>2.2. Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев,
                    если обработка необходима для уточнения персональных данных);</p>

                <p>2.3. Веб-сайт – совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных,
                    обеспечивающих их доступность в сети интернет по сетевому адресу <a
                        href="https://graf-yagoda.ru/">https://graf-yagoda.ru/</a>;</p>

                <p>2.4. Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных, и
                    обеспечивающих их обработку информационных технологий и технических средств;</p>

                <p>2.5. Обезличивание персональных данных — действия, в результате которых невозможно определить без использования
                    дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту
                    персональных данных;</p>

                <p>2.6. Обработка персональных данных – любое действие (операция) или совокупность действий (операций), совершаемых с
                    использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор,
                    запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу
                    (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных;
                </p>

                <p>2.7. Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или
                    совместно с другими лицами организующие и осуществляющие обработку персональных данных, а также определяющие цели
                    обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с
                    персональными данными;</p>

                <p>2.8. Персональные данные – любая информация, относящаяся прямо или косвенно к определенному или определяемому
                    Пользователю веб-сайта&nbsp;<a href="https://graf-yagoda.ru/">https://graf-yagoda.ru/</a>;</p>

                <p>2.9. Пользователь – любой посетитель веб-сайта&nbsp;<a href="https://graf-yagoda.ru/">https://graf-yagoda.ru/</a>;
                </p>

                <p>2.10. Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу
                    или определенному кругу лиц;</p>

                <p>2.11. Распространение персональных данных – любые действия, направленные на раскрытие персональных данных
                    неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного
                    круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в
                    информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом;
                </p>

                <p>2.12. Уничтожение персональных данных – любые действия, в результате которых персональные данные уничтожаются
                    безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе
                    персональных данных и уничтожаются материальные носители персональных данных.</p>

                <h2>3. Оператор может обрабатывать следующие персональные данные Пользователя</h2>

                <p>3.1. Фамилия, имя, отчество;</p>

                <p>3.2. Номера телефонов;</p>

                <p>3.3. Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов «cookie») с помощью
                    сервисов интернет-статистики (Яндекс Метрика).</p>

                <p>3.4. Вышеперечисленные данные далее по тексту Политики объединены общим понятием Персональные данные.</p>

                <h2>4. Цели обработки персональных данных</h2>

                <p>4.1. Цель обработки персональных данных Пользователя — информирование Пользователя посредством отправки электронных
                    писем; заключение, исполнение и прекращение гражданско-правовых договоров.</p>

                <p>4.2. Также Оператор имеет право направлять Пользователю уведомления о новых продуктах и услугах, специальных
                    предложениях и различных событиях. Пользователь всегда может отказаться от получения информационных сообщений,
                    направив Оператору письмо на адрес электронной почты <a href="mailto:graf-yagoda@yandex.ru">graf-yagoda@yandex.ru</a> с пометкой «Отказ от уведомлений о новых
                    продуктах и услугах и специальных предложениях».</p>

                <p>4.3. Обезличенные данные Пользователей, собираемые с помощью сервисов интернет-статистики, служат для сбора
                    информации о действиях Пользователей на сайте, улучшения качества сайта и его содержания.</p>

                <h2>5. Правовые основания обработки персональных данных</h2>

                <p>5.1. Оператор обрабатывает персональные данные Пользователя только в случае их заполнения и/или отправки
                    Пользователем самостоятельно через специальные формы, расположенные на сайте <a
                        href="https://graf-yagoda.ru/">https://graf-yagoda.ru/</a> Заполняя соответствующие формы и/или отправляя свои
                    персональные данные Оператору, Пользователь выражает свое согласие с данной Политикой.</p>

                <p>5.2. Оператор обрабатывает обезличенные данные о Пользователе в случае, если это разрешено в настройках браузера
                    Пользователя (включено сохранение файлов «cookie» и использование технологии JavaScript).</p>

                <h2>6. Порядок сбора, хранения, передачи и других видов обработки персональных данных</h2>

                <p>Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых,
                    организационных и технических мер, необходимых для выполнения в полном объеме требований действующего
                    законодательства в области защиты персональных данных.</p>

                <p>6.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к
                    персональным данным неуполномоченных лиц.</p>

                <p>6.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением
                    случаев, связанных с исполнением действующего законодательства.</p>

                <p>6.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно,
                    путем направления Оператору уведомление на адрес электронной почты Оператора&nbsp;<a
                        href="mailto:graf-yagoda@yandex.ru">graf-yagoda@yandex.ru</a> с пометкой
                    «Актуализация персональных данных».</p>

                <p>6.4. Срок обработки персональных данных по достижению цели обработки. Пользователь может в любой момент отозвать свое
                    согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на
                    электронный адрес Оператора <a href="mailto:graf-yagoda@yandex.ru">graf-yagoda@yandex.ru</a> c пометкой «Отзыв
                    согласия на обработку персональных данных».
                </p>

                <h2>7. Заключительные положения</h2>

                <p>7.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных
                    данных, обратившись к Оператору с помощью электронной почты <a
                        href="mailto:graf-yagoda@yandex.ru">graf-yagoda@yandex.ru</a> </p>

                <p>7.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика
                    действует бессрочно до замены ее новой версией.</p>
            </div>
        </div>
    );
};

export default PolititcPage;
